/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StoredObjectBucketsEnum {
    UMM = 'umm',
    INVOICE = 'invoice',
    UREAD = 'uread',
    PORTAL = 'portal',
}